<template>
  <div class="home-zzgz" v-loading="loading">
    <p class="hy-title">解决方案</p>
    <div class="zzgz-content" @mouseleave="hoverIndex = null">
      <article
        v-for="(item, index) in solutionCards"
        :key="index"
        class="zzgz-card"
        :style="cardTransformStyle(index)"
        @mouseenter="hoverIndex = index"
      >
        <div class="zzgz-card__media">
          <img :src="cover(item)" :alt="item.title" />
        </div>
        <div class="zzgz-card__body">
          <h3 class="zzgz-card__title">{{ item.title }}</h3>
          <span class="zzgz-card__accent" aria-hidden="true" />
          <p class="zzgz-card__desc">{{ item.summary }}</p>
          <a
            class="zzgz-card__cta"
            :class="{ 'is-active': hoverIndex === index }"
            href="javascript:;"
            @click="openSolution(item)"
          >
            查看方案
            <span class="zzgz-card__cta-arrow" aria-hidden="true">→</span>
          </a>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import api, { getMediaUrl } from "@/api";
export default {
  name: "HomeZzgz",
  data() {
    return {
      loading: false,
      hoverIndex: null,
      solutionCards: [
        // {
        //   title: "国有企事业单位",
        //   desc: "提供国企事业单位自定义业务的干部人事智能管理系统。",
        //   img: require("@/assets/images/zzgz-bg-1.png"),
        // },
        // {
        //   title: "省市级一体化解决方案",
        //   desc: "提供省市县三级组工业务全覆盖的一体化综合管理平台。",
        //   img: require("@/assets/images/zzgz-bg-2.png"),
        // },
        // {
        //   title: "部委、各级党政机关",
        //   desc: "提供部委及各级党政机关全流程干部人事管理系统。",
        //   img: require("@/assets/images/zzgz-bg-3.png"),
        // },
        // {
        //   title: "垂管单位",
        //   desc: "提供满足垂管及特殊单位个性化需求的干部人事管理平台。",
        //   img: require("@/assets/images/zzgz-bg-4.png"),
        // },
        // {
        //   title: "街道编外人员",
        //   desc: "提供乡镇、街道等基层单位简单、实用的编外人员管理系统。",
        //   img: require("@/assets/images/zzgz-bg-5.png"),
        // },
      ],
    };
  },
  async created() {
    this.loading = true;
    try {
      this.solutionCards = (await api.getSolutions()) || [];
    } finally {
      this.loading = false;
    }
  },
  methods: {
    cover(item) {
      return getMediaUrl(item.coverImage) || sliceUrl("编组.png");
    },
    openSolution(item) {
      if (!item) return;
      if (item.linkUrl) {
        window.open(item.linkUrl, "_blank", "noopener");
        return;
      }
      this.$router.push(`/solutions/${item.id}`);
    },
    cardTransformStyle(index) {
      if (this.hoverIndex === null) {
        return { transform: "translateY(0)" };
      }
      const d = Math.abs(index - this.hoverIndex);
      let y = 0;
      if (d === 0) y = -40;
      else if (d === 1) y = -20;
      else if (d === 2) y = -10;
      return { transform: `translateY(${y}px)` };
    },
  },
};
</script>

<style lang="less">
.home-zzgz {
  position: relative;
  width: 100%;
  padding-top: 60px;
  .hy-title {
    margin-bottom: 50px;
  }
  .zzgz-content {
    height: 560px;
    padding-bottom: 60px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    margin: 0 auto;
  }

  .zzgz-card {
    position: relative;
    width: 312px;
    height: 482px;
    margin: 0 10px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(56, 73, 89, 0.12);
    overflow: hidden;
    transition: transform 0.35s ease, box-shadow 0.35s ease;
    cursor: default;
  }

  .zzgz-card:hover {
    box-shadow: 0 14px 32px rgba(56, 73, 89, 0.18);
  }

  .zzgz-card__media {
    position: relative;
    height: 310px;
    overflow: hidden;
    img {
      position: absolute;
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      z-index: 1;
    }
    // &::after{
    //     content: '';
    //     position: absolute;
    //     left: 0;
    //     bottom: 0;
    //     width: 100%;
    //     height: 100%;
    //     background-image: url('@/assets/images/card-bottom-img.png') ;
    //     background-size:contain;
    //     background-position: center bottom;
    //     background-repeat: no-repeat;
    //     z-index: 2;
    // }
  }

  .zzgz-card__media img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .zzgz-card__body {
    position: relative;
    z-index: 10;
    padding: 0 20px;
  }

  .zzgz-card__title {
    margin-top: -48px;
    height: 32px;
    line-height: 32px;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.35;
    color: rgba(51, 51, 51, 1);
  }

  .zzgz-card__accent {
    position: relative;
    display: block;
    margin-top: 10px;
    margin-bottom: 14px;
    width: 40px;
    height: 4px;
    background: rgba(208, 2, 27, 1);
    &::after {
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      width: 4px;
      height: 4px;
      background: rgba(254, 105, 58, 1);
      transform: translateX(8px);
    }
  }

  .zzgz-card__desc {
    display: -webkit-box;
    -webkit-line-clamp: 4;
    line-clamp: 4;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    height: 90px;
    line-height: 1.3;
    font-size: 18px;
    color: rgba(102, 102, 102, 1);
    text-indent: 2em;
  }

  .zzgz-card__cta {
    margin-top: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    font-size: 20px;
    color: rgba(51, 51, 51, 1);
    text-decoration: none;
    transition: color 0.25s ease;
  }

  .zzgz-card__cta.is-active {
    color: rgba(244, 54, 8, 1);
  }

  .zzgz-card__cta-arrow {
    font-size: 14px;
  }
}
</style>
